import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ReadjustmentRequestDto } from '@app/data/dtos/ptrab/irpf-readjustment/readjustment-request.dto';
import { ReadjustmentDto } from '@app/data/dtos/ptrab/irpf-readjustment/readjustment.dto';
import { mapReadjustmentData } from '@app/data/mappers/ptrab/irpf-readjustment/irpf-readjustment.mappers';
import { IrpfReadjustmentRepository } from '@app/domain/repositories/ptrab/irpf-readjustment/irpf-readjustment.repository.contract';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Readjustment } from '@app/entities/models/ptrab/irpf-readjustment/readjustment.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class IrpfReadjustmentRepositoryImpl extends MRepository implements IrpfReadjustmentRepository {
  readjustmentUrl = `/ptrab/personal-income-tax/navarra-regularization`;

  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  getReadjustment(): Observable<Readjustment> {
    return this.get<IDataResponse<ReadjustmentDto>>(this.readjustmentUrl, {
      context: new HttpContext().set(SECTION_KEY, 'irpf-navarra-regularization')
    }).pipe(map(mapReadjustmentData));
  }

  setRegularization(params: ReadjustmentRequestDto, authorization: TwoFactorAuthorization): Observable<MSafeAny> {
    const request = {
      body: {
        params,
        authorization
      }
    };
    return this.post(this.readjustmentUrl, request);
  }
}
